import React from "react";
import Dialog from "material-ui/Dialog";
import QuestionPrompt from "../components/QuestionPrompt";
import FlatButton from "material-ui/FlatButton";
import RaisedButton from "material-ui/RaisedButton";
import Bookmark from "material-ui/svg-icons/action/bookmark";
import IconButton from "material-ui/IconButton";
import AddNoteIcon from "material-ui/svg-icons/action/note-add";
import QuestionNoteModal from "./QuestionNoteModal";
import { Card, CardHeader, CardText } from "material-ui/Card";
import AnswerInfluenceCard from '../components/AnswerInfluenceCard';
import { Provider } from 'react-redux';
import { store } from '../index';
import {IntlProvider, injectIntl} from 'react-intl';
import {getTranslationMessages} from "../reducer/translations"

var dialogStyles = {
  position: "absolute",
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)"
};

// const noteStyle = {
//   backgroundColor: "#fffbe8",
//   border: "1px solid #e6cfa4",
//   marginTop: 14,
//   marginLeft: 14,
//   marginRight: 14,
//   borderRadius: 2,
//   marginBottom: 10,
//   width: '90%',
//   margin: '10px auto',
//   backgroundColor: '#fffaf2',
//   border: '1px solid #c7c1b5'
// };

class AnswerEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flagged: props.answer ? props.answer.flagged : false,
      editNoteModalOpen: false,
      selectedAnswer: props.answer
    };
  }

  componentWillReceiveProps(props) {
    if (props.answer && props.answer !== this.props.answer) {
      this.setState({
        flagged: props.answer.flagged,
        selectedAnswer: props.answer
      });
    }
  }

  render() {
    let { open, question, readOnly } = this.props;
    var intl = this.props.intl;
    let flagged = this.state.flagged;
    if (!question) {
      question = {
        answers: []
      };
    }
    let actions = [];
    if (!readOnly) {
      let hasNote = !!(this.props.answer && this.props.answer.note && this.props.answer.note.length)
      actions.push(
        <FlatButton
          onClick={this.handleEditNote}
          label={intl.formatMessage({id:"general.notesBtnQuestionModal", defaultMessage:"{hasNote, select, true {Edit Note} other {Add Note}}"}, {hasNote: hasNote})}
          icon={<AddNoteIcon />}
        />
      );
      actions.push(
        <FlatButton label="cancel" onClick={this.props.onRequestClose} />
      );
      actions.push(
        <RaisedButton
          onClick={this.onSave.bind(this)}
          primary={true}
          label={intl.formatMessage({ id:"general.save", defaultMessage:"Save" })}
        />
      );
    } else {
      actions.push(
        <RaisedButton
          onClick={this.props.onRequestClose}
          primary={false}
          label={intl.formatMessage({id:"general.close", defaultMessage:"Close"})}
        />
      );
    }

    let trIDForResponse = (this.props.response && this.props.response.userEdits) ? this.props.response.userEdits.trIDForResponse : -1;
    let messages = getTranslationMessages(trIDForResponse)
    return (

      <Dialog
        open={open}
        onRequestClose={this.props.onRequestClose}
        actions={actions}
        contentStyle={dialogStyles}
        autoScrollBodyContent={true}
      >
        <IconButton
          style={{
            position: "absolute",
            right: 20,
            top: 0,
            border: 0,
            margin: 0,
            padding: 0
          }}
          iconStyle={{ width: 48, height: 48 }}
          onClick={this.onToggleFlagged.bind(this)}
        >
          {!readOnly ? (
            <Bookmark color={flagged ? "rgb(22, 126, 82)" : "#c4c4c4"} />
          ) : null}
        </IconButton>
        <IntlProvider locale="en" defaultLocale="en" messages={messages}> {/*TODO: why is this not being covered by the IntlProvider in routes?*/}
          <QuestionPrompt
            readOnly={readOnly}
            ref="prompt"
            {...question}
            answer={this.state.selectedAnswer}
            onChange={this.handleAnswerChange}
            section={this.props.answer ? this.props.answer.answeredInSection : null}
            trQuestion={this.props.trQuestion}
          />

          {this.props.answer &&
          this.props.answer.note &&
          this.props.answer.note.length ? (
            <Card style={{
              width: '85%',
              margin: '10px auto',
              display: open ? 'block' : 'none',
              backgroundColor: '#fffaf2',
              border: '1px solid #c7c1b5',
              marginBottom: 20
            }}>
              <CardHeader title={intl.formatMessage({ id:"general.notes", defaultMessage:"Notes" })} />
                <CardText>
                <div style={{marginTop: -24, padding:0}}
                  dangerouslySetInnerHTML={{ __html: this.props.answer.note }}
                />
                </CardText>
            </Card>
          ) : null}
          <QuestionNoteModal
            onSave={this.handleSaveNote}
            onRequestClose={this.handleCloseEditNote}
            open={this.state.editNoteModalOpen}
            defaultValue={this.props.answer ? this.props.answer.note : null}
            question={question}
            trQuestion={this.props.trQuestion}
          />

          {/* Not sure why this is needed, but for some reason the context isn't being passed down */}
          <Provider store={store}>
          <AnswerInfluenceCard question={question} answer={this.state.selectedAnswer} section={this.props.section} />
          </Provider>
        </IntlProvider>
      </Dialog>
    );
  }

  handleAnswerChange = (e, value, a) => {
    this.setState({selectedAnswer: {
      ...this.props.answer,
      value: value
    }});
  }

  onSave() {
    if (!!this.props.onSave) {
      var section = this.props.answer
        ? this.props.answer.answeredInSection
        : "monitoring";
      this.props.onSave(
        this.props.question.id,
        this.refs.prompt.getValue(),
        section,
        this.props.response
      );
    }
    this.props.onRequestClose();
  }

  handleEditNote = () => {
    this.setState({ editNoteModalOpen: true });
  };

  handleCloseEditNote = () => {
    this.setState({ editNoteModalOpen: false });
  };

  onToggleFlagged() {
    this.setState({
      flagged: !this.state.flagged
    });
    if (this.props.onToggleFlagged) {
      this.props.onToggleFlagged(this.props.question.id, this.props.response);
    }
  }

  handleSaveNote = value => {
    this.props.onSaveNote(this.props.question.id, value, this.props.response);
    setTimeout(() => this.forceUpdate(), 200);
  };
}

export default injectIntl(AnswerEditModal);
